import { createQueryKey } from '../../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../../query/types';

const membershipKeys = <T extends QueryKey>(keys: T) =>
  createQueryKey({
    all: [...keys, 'memberships'] as const,
    id: <U extends QueryKeyParam>(itemId: U) =>
      createQueryKey({
        all: [...keys, 'memberships', itemId] as const,
        detail: [...keys, 'memberships', itemId, 'detail'] as const,
      }),
    export: [...keys, 'export'] as const,
  });

export { membershipKeys };
